"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCandidates = useCandidates;
const react_1 = require("react");
const stores_1 = require("../stores/index.js");
const view_models_1 = require("../../view-models/index.js");
function useCandidates() {
    const candidates = (0, stores_1.useCalculatorStore)((state) => state.data.candidates);
    const persons = (0, stores_1.useCalculatorStore)((state) => state.data.persons);
    const organizations = (0, stores_1.useCalculatorStore)((state) => state.data.organizations);
    const baseUrl = (0, stores_1.useCalculatorStore)((state) => state.baseUrl);
    const personsMap = (0, react_1.useMemo)(() => new Map(persons?.map((p) => [p.id, (0, view_models_1.personViewModel)(p, baseUrl)]) ?? []), [persons, baseUrl]);
    const organizationsMap = (0, react_1.useMemo)(() => new Map(organizations?.map((o) => [o.id, (0, view_models_1.organizationViewModel)(o, baseUrl)]) ?? []), [organizations, baseUrl]);
    return (0, react_1.useMemo)(() => (0, view_models_1.candidatesViewModel)(candidates, personsMap, organizationsMap, baseUrl), [candidates, personsMap, organizationsMap, baseUrl]);
}
